/* Brand Filter */
var triggers = $('.brand-filter a');
var filters = $('.brand-list .brand-item .brand-name');

triggers.click(function() {
  $(".all-link").removeClass('active');
  var takeLetter = $(this).text(), result = 0;
  filters.parent().hide();
  triggers.removeClass('active');
  $(this).addClass('active');
  $('#result').show();
  filters.each(function(i) {
    if ( RegExp('^'+takeLetter).test($(this).text()) ) {
      result += 1;
      $(this).parent().fadeIn(222);
    } 
  });
  $('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
  //if (result<1) {alert('There is no result.');}
});

$(".brand-filter .all-link").click(function(){
  $(this).addClass('active');
  filters.parent().show();
  triggers.removeClass('active');
  $('#result').hide();
});